define(
  'modules/menu',
  [
    'jquery',
    'modules/tracking'
  ],
  function (
    $,
    M_Tracking
  ) {
    'use strict';

    var classes = {
      isActive: 'is--active'
    };
    var selectors = {
      menuContainer: '.js-menu-container',
      menuToggle: '.js-menu-toggle',
      menuClose: '.js-menu-close',
      menuLink: '.js-menu-link',
      socialLink: '.js-social-link'
    };
    var attributes = {
      trackingLabel: 'data-tracking-label'
    };
    var $menuContainer
      , $menuToggle
      , $menuClose;


    function init () {
      getElems();
      bindEvents();

      $menuContainer.show(); // note, this element is set to display:none in AEM HTML component styles
    }

    function getElems () {
      $menuContainer = $(selectors.menuContainer);
      $menuToggle = $(selectors.menuToggle);
      $menuClose = $(selectors.menuClose);
    }

    function bindEvents () {
      $menuToggle.on('click', onMenuToggleClick);
      $menuClose.on('click', onMenuCloseClick);
      $menuContainer.find(selectors.menuLink).on('click', onMenuLinkClick);
      $menuContainer.find(selectors.socialLink).on('click', onSocialLinkClick);
    }

    function onMenuToggleClick (e) {
      e.preventDefault();
      e.stopPropagation();

      if ($menuContainer.hasClass(classes.isActive)) {
        closeMenu();
        M_Tracking.trackEvent('access-menu', 'Close');
      } else {
        openMenu();
        M_Tracking.trackEvent('access-menu', 'Open');
      }
    }

    function onMenuCloseClick () {
      M_Tracking.trackEvent('access-menu', 'Close');
      closeMenu();
    }

    function openMenu () {
      $menuContainer.addClass(classes.isActive);
    }

    function closeMenu () {
      $menuContainer.removeClass(classes.isActive);
    }

    function onMenuLinkClick (e) {
      M_Tracking.trackEvent('click-cta', $(e.currentTarget).attr(attributes.trackingLabel));
    }

    function onSocialLinkClick (e) {
      M_Tracking.trackEvent('click-cta', $(e.currentTarget).attr(attributes.trackingLabel));
    }


    return {
      init: init,
      closeMenu: closeMenu
    }
});

